import { Outlet, useParams } from 'react-router-dom'
import { useCurrentStore, useEditOrderItem, useOrdering } from 'hooks'
import { Box, Stack, Typography } from '@mui/material'
import { CartDrawer } from 'components/ordering/CartDrawer'
import { EditOrderItemDialog } from 'components/ordering/EditOrderItemDialog'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const LoadingError = (error: any) => {
  const { t } = useTranslation()
  return (
    <Stack spacing={2} sx={{ textAlign: 'center', margin: 4 }}>
      <Typography variant="h4" color="error">
        {t('Error loading table.')}
      </Typography>
      <Typography variant="body2">{error?.message}</Typography>
    </Stack>
  )
}

export const TableOrderingLayout = () => {
  const { store } = useCurrentStore()
  const { order, createOrder, clearOrder } = useOrdering()
  const { tableId } = useParams()
  const { editingOrderItem } = useEditOrderItem()
  const tableInfo = store?.table_info

  // Clear order if the table ID mismatch
  useEffect(() => {
    if (tableInfo && tableInfo.table_id !== tableId) {
      clearOrder()
    }
  }, [tableId, tableInfo, clearOrder])

  // Create order if not exists and table info is loaded
  useEffect(() => {
    if (!order && tableInfo) {
      createOrder({
        orderType: 'dinein',
        tableId: tableInfo.table_id,
        isAsap: false,
      })
    }
  }, [order, createOrder, tableInfo])

  if (!tableInfo) {
    return <LoadingError />
  }

  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {order && <Outlet />}
      <CartDrawer />
      {editingOrderItem && <EditOrderItemDialog />}
    </Box>
  )
}
